const ImageField = ({src, value, height, width}: {src: string; value?: string; height?: number; width?: number}) => {
  return (
    <dd>
      {value}
      <span className="thumb_img">
        <img src={src} alt="카드정보이미지" className="img_g" height={height} width={width} />
      </span>
    </dd>
  );
};

export default ImageField;
